import { FC, Fragment, InputHTMLAttributes } from "react";

export type InputTextRightWhiteprops = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  spanRight?: string;
  textDescribe?: string;
};

export const InputTextRightWhite: FC<InputTextRightWhiteprops> = ({
  label,
  spanRight,
  textDescribe,
  ...props
}) => {
  return (
    <Fragment>
      <div className="flex flex-row gap-2 items-center">
        <label
          htmlFor="price"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          {label}
        </label>
        <div className="relative rounded-md">
          <input
            {...props}
            className={`block w-full rounded-md pl-2 pr-[35px] text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:border-primary sm:text-sm sm:leading-6 ${props?.className}`}
          />
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <span
              id="price-currency"
              className="text-gray-500 sm:text-sm text-left"
            >
              {spanRight}
            </span>
          </div>
        </div>
        <p className={`mt-1 text-sm text-gray-400`}>{textDescribe}</p>
      </div>
    </Fragment>
  );
};
